// middleware/auth.ts
import { defineNuxtRouteMiddleware, navigateTo } from '#app'
import { useRuntimeConfig, useLocalePath } from '#imports'
import useAuth from '~/composables/auth/useAuth'

export default defineNuxtRouteMiddleware(async (to) => {
  if (!to.meta.requiresAuth) return

  const localePath = useLocalePath()
  const { appEnv } = useRuntimeConfig().public

  // skip in dev mode, because cookies is not secure
  if (process.server && appEnv !== 'production') {
    return
  }

  const { checkAuthStatus } = useAuth()

  // Check auth status without auto-redirect
  const isAuthenticated = await checkAuthStatus()

  // if not authenticated
  if (!isAuthenticated) {
    // Remove locale prefix from path to avoid double prefixing when using localePath
    const cleanPath = to.fullPath.replace(/^\/(de-de|en-us)/, '') || '/'
    const redirectTo = encodeURIComponent(cleanPath)

    return navigateTo(localePath(`/login?redirectTo=${redirectTo}`), {
      external: true,
    })
  }
})
